import { jsx as _jsx } from "react/jsx-runtime";
import { DeleteWithConfirmButton } from "react-admin";
import React from "react";
export const DeleteItemButton = ({ customConfirmContent, customConfirmTitle, ...props }) => {
    return (_jsx(DeleteWithConfirmButton, { label: "", size: "medium", confirmTitle: customConfirmTitle ??
            "Are you sure you want to delete this item? You can’t undo this action.", confirmContent: customConfirmContent ??
            "IMPORTANT: It is always better to hide items than to delete them. " +
                "Deleting an item that the players interacted with might cause unexpected issues.", ...props }));
};
